export class AddCategory {
  competitionId: String;
  date: String;
  price: String;
  pass: Number;
  isAbqm: Boolean;
}
